/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React, { useState, forwardRef } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { checkErrorResponse, Logger, LoggerTypes } from '../../../../../utils'
import { DialogFormEdit } from '../../../../dialogs'
import { AttributeWeatherForm } from '../../AttributeWeatherForm'

export const AttributeWeatherDialogCreate = forwardRef(
  ({ currentProject, currentScenario, openDialog, setOpenDialog, actionCreateDispatch }, ref) => {
    const [errors, setErrors] = useState(null)
    const [progress, setProgress] = useState(null)
    const [isSuccess, setIsSuccess] = useState(false)

    const dispatch = useDispatch()
    const { enqueueSnackbar } = useSnackbar()
    const { t } = useTranslation()

    const title = currentScenario
      ? t('attributes.weather_data.create.scenario')
      : currentProject
      ? t('attributes.weather_data.create.project')
      : t('attributes.weather_data.create.global')

    const onUploadProgress = (_progress) => {
      Logger.trace(LoggerTypes.CONTROLLER, 'AttributeWeatherDialogCreate.onUploadProgress()', { _progress })

      setProgress(_progress)
    }

    /**
     * Action received from the Weather Form.
     * @see AttributeWeatherForm
     *
     * @param {object} newWeather New Weather attribute object to create.
     * @param {string} newWeatherId here it's null.
     * @param {func} onSuccess Function to execute on success.
     */
    const onDispatchAction = (newWeather, newWeatherId, onSuccess) => {
      Logger.trace(LoggerTypes.CONTROLLER, 'AttributeWeatherDialogCreate.onDispatchAction()', {
        newWeather,
        newWeatherId
      })

      setErrors(null)

      dispatch(actionCreateDispatch(newWeather, onUploadProgress, currentProject?.id, currentScenario?.id))
        .then((res) => {
          Logger.trace(
            LoggerTypes.CONTROLLER,
            'AttributeWeatherDialogCreate.onDispatchAction().dispatch(actionCreateDispatch(...)).then()',
            {
              res
            }
          )

          setIsSuccess(true)

          if (onSuccess && typeof onSuccess === 'function') {
            onSuccess(res)
          }
        })
        .catch((res) => {
          Logger.trace(
            LoggerTypes.WARN,
            'AttributeWeatherDialogCreate.onDispatchAction().dispatch(actionCreateDispatch(...)).catch()',
            {
              res
            }
          )

          checkErrorResponse(res, enqueueSnackbar, t)

          if (res?.response?.data?.fields) {
            setErrors(res.response.data.fields)
          }

          setIsSuccess(false)
        })
    }

    Logger.trace(LoggerTypes.CONTROLLER, 'AttributeWeatherDialogCreate.render()', { currentProject, currentScenario })

    return (
      <DialogFormEdit className="attribute-form" openDialog={openDialog} setOpenDialog={setOpenDialog}>
        <AttributeWeatherForm
          ref={ref}
          title={title}
          setOpenDialogWeather={setOpenDialog}
          dispatchAction={onDispatchAction}
          errors={errors}
          progress={progress}
          isSuccess={isSuccess}
        />
      </DialogFormEdit>
    )
  }
)

AttributeWeatherDialogCreate.displayName = 'AttributeWeatherDialogCreate'

AttributeWeatherDialogCreate.propTypes = {
  currentProject: PropTypes.object,
  currentScenario: PropTypes.object,
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  actionCreateDispatch: PropTypes.func.isRequired
}

AttributeWeatherDialogCreate.defaultProps = {
  currentProject: null,
  currentScenario: null,
  openDialog: false,
  setOpenDialog: () => {},
  actionCreateDispatch: () => {}
}
